import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {apiService} from '../../../../../service/api.service';
@Component({
  selector: 'app-modal-confirmar-eliminacion',
  templateUrl: './modal-confirmar-eliminacion.component.html',
  styleUrls: ['./modal-confirmar-eliminacion.component.css']
})
export class ModalConfirmarEliminacionComponent implements OnInit {
  idMedioVerificacion:number;
  tipo:string;
  constructor(
    public dialogRef: MatDialogRef<ModalConfirmarEliminacionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public api:apiService
  ) {}

  ngOnInit(): void {
    this.idMedioVerificacion = this.data.idMedioVerificacion
    this.tipo = this.data.tipo
  }

  confirmarEliminacion(){
    console.log(this.tipo)
    if(this.tipo == 'mediosVerificacion'){
      this.api.API_POST_eliminarMediosVerificacion(this.idMedioVerificacion).subscribe((response) => {

        this.dialogRef.close('refresh');
  
      },
      (err) => {
        console.log(err)
      })
    }else{
      this.api.API_POST_eliminarVinculacionMedioAutoevaluacion(this.idMedioVerificacion).subscribe((response) => {

        this.dialogRef.close('refresh');
  
      },
      (err) => {
        console.log(err)
      })
    }
    
  }
}
